import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeFourTitle from '../../ThemeFour/common/ThemeFourTitle';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeNinePrivacyPolicyScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const createMarkup = data => {
		return { __html: data };
	};

	const contentStyle = operator && operator.name === 'losnavegadores' ? {
		overflowY: 'scroll',
		maxHeight: 'calc(100vh - 200px)',  // Scroll after 200px
	} : {};

	return (
		<div className="">
			<KuposHelmet />
			<HeroSection
				title="Políticas de privacidad"
				description="Home / Políticas de privacidad        "
				heroImage={getIcons('tncBanner', operator)}
			/>

			<div className="new-container" style={{ marginTop: 20 }}>
				<ThemeFourTitle title=" Políticas de privacidad" />


			</div>

			<div className="new-container mb10 mt10">
				{operator && operator.operator_name === 'losnavegadores' ? (
					<div
						dangerouslySetInnerHTML={createMarkup(
							operator && operator.privacy_policy ? operator.privacy_policy : '',
						)}
						className="lh-1-3 terms-and-conditions font11 scroll"
						style={{ fontSize: '13px', ...contentStyle }}  // Apply conditional style
					/>
				) : (
					<div
						dangerouslySetInnerHTML={createMarkup(
							operator && operator.privacy_policy ? operator.privacy_policy : '',
						)}
						className="lh-1-3 terms-and-conditions font11"
						style={{ fontSize: '13px', ...contentStyle }}  // Apply conditional style
					/>
				)}

			</div>

		</div>
	);
};

function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		// actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeNinePrivacyPolicyScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNinePrivacyPolicyScreen.js